export class BrowserPrintUnavailableError extends Error {
  override name = "BrowserPrintUnavailableError";

  constructor(
    message = "BrowserPrint SDK is not available on window.BrowserPrint.",
    options?: ErrorOptions,
  ) {
    super(message, options);
  }
}

export class BrowserPrintDeviceError extends Error {
  override name = "BrowserPrintDeviceError";
}

export class BrowserPrintTimeoutError extends Error {
  override name = "BrowserPrintTimeoutError";
}

export class BrowserPrintSendError extends Error {
  override name = "BrowserPrintSendError";
}
